import {useCallback, useEffect, useRef, useState} from "react";

export type LoadingStates = Record<string, boolean>;

export const useChatroomLoading = () => {
    const [loadingStates, setLoadingStates] = useState<LoadingStates>({});
    const loadingStatesRef = useRef(loadingStates)

    useEffect(() => {
        loadingStatesRef.current = loadingStates;
    }, [loadingStates]);

    const setLoading = (chatroomId: string, loading: boolean) => {
        setLoadingStates((loadingStates) => {
            return {
                ...loadingStates,
                [chatroomId]: loading
            }
        })
    }

    const isLoading = useCallback((chatroomId: string) => {
        return loadingStates[chatroomId] ?? false;
    }, [loadingStates])

    return {
        setLoading,
        isLoading,
    }
}
